module.exports = __webpack_public_path__ + "img/course109.16d6a27b.png";